// This service handles the communication with the backend API
// Using relative URLs for API requests that will be proxied through the dev server
// const wsHost = 'api.eyo.zenitech.co.uk'; // Keep original host for WebSocket connections
const host = 'api.eyo.zenitech.co.uk';

let ws = null;

const send = (action, content) => {
    ws.send(JSON.stringify({ action, content }));
};

export const signup = (name, birthYear, genre) => {
    return fetch(
        `https://${host}/api/client/user`,
        {
            method: 'POST',
            body: JSON.stringify({ name, birthYear, genre }),
            headers: {
                'Content-Type': 'application/json' 
            }
        })
        .then(response => {
            if (response.status >= 400) {
                return response.json()
                    .then(response => { throw new Error(response.message) });
            }
            return response.json();
        });
};

export const user = token => {
    return fetch(`https://${host}/api/client/user/${token}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => {
            if (response.status >= 400) {
                return response.json()
                    .then(response => { throw new Error(response.message) });
            }
            return response.json();
        });
};

export const login = (token, onOpen, onMessage, onError, onClose) => {
    if (ws) {
        ws.close();
    }
    ws = new WebSocket(`wss://${host}/api/client?token=${token}`);
    ws.onopen = onOpen;
    ws.onerror = onError;
    ws.onclose = onClose;
    ws.onmessage = message => {
        console.log('Message received', message.data);
        onMessage(JSON.parse(message.data));
    };
};

export const logout = () => {
    if (ws === null) {
        return;
    }
    ws.close();
    ws = null;
};

export const guess = optionIndex => {
    send('guess', { optionIndex });
};

export const half = () => {
    send('half', {});
};

export const heart = () => {
    send('heart', {});
};
